// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bf43d8b2","66":"1e8ba971","103":"52036c32","147":"1c7c9bf4","204":"e1cefdf0","225":"ef375f98","299":"3e30da5b","453":"cb2ae910","530":"86723cb6","589":"21639aff","688":"92d7a5b2","725":"083f7429","801":"3bca0552"}[chunkId] + ".chunk.js";
};